import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100px;
  margin-top: 0.75rem;
  border-radius: 4px;
  padding: 1rem;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1D86FF;
  
  .info-- {
    display: flex;
    .logo-- {
      position: absolute;
      display: flex;
      width: 5rem;
      height: 5rem;
      top: -15px;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name--company {
      display: flex;
      width: 100%;
      max-height: 20px;
      margin-left: 5.5rem;
      flex-direction: column;
      span {
        display: flex;
        width: 100%;
        font-size: 1.3rem;
        font-weight: bolder;
        justify-content: left;
        align-items: center;
      }
    }
  }

  .full-- {
    position: absolute;
    right: 5px;
    top: 5px;
    display: flex;
    align-items: center;
    gap: 0.25rem;

    > span {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: .2rem;
      color: #1D86FF;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
      }
    }
  }

  .--chart {
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    canvas {
      max-height: 400px;
    }
  }
`;

export const MessageCards = styled.div`
  margin-top: 2.5rem;
  padding: 0;

  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;
    
    span {
      font-size: 1.15rem;
      font-weight: 700;
      color: #1e293b;
      letter-spacing: -0.01em;
    }
  }

  .month-block {
    margin-bottom: 1.75rem;
    animation: fadeSlideIn 0.4s ease forwards;
    opacity: 0;
    background: #fcfcfcff;
    border-radius: 12px;
    border: 1px solid #e2e2e2;
    padding: 1rem 1.15rem;

    &:nth-child(2) { animation-delay: 0.05s; }
    &:nth-child(3) { animation-delay: 0.1s; }
    &:nth-child(4) { animation-delay: 0.15s; }
    &:nth-child(5) { animation-delay: 0.2s; }
    &:nth-child(6) { animation-delay: 0.25s; }

    &:last-child {
      margin-bottom: 0;
    }
  }

  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .month-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.85rem;

    .month-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 8px;
      background: linear-gradient(135deg, #1D86FF, #3b9cff);
      color: #fff;
      font-size: 0.85rem;
      flex-shrink: 0;
      box-shadow: 0 2px 6px rgba(29, 134, 255, 0.3);
    }

    span {
      font-size: 0.95rem;
      font-weight: 700;
      color: #1e3a5f;
      letter-spacing: 0.01em;
    }
  }

  .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.85rem;
  }
`;

export const CategoryCard = styled.div`
  position: relative;
  background: ${props => props.$bgColor || '#f9fafb'};
  border-radius: 12px;
  padding: 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  border: 1px solid ${props => `${props.$color}22` || '#e5e7eb'};
  border-left: 4px solid ${props => props.$color || '#d1d5db'};

  .card-header {
    display: flex;
    align-items: center;
    gap: 0.6rem;

    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border-radius: 10px;
      background: linear-gradient(135deg, ${props => props.$color || '#6b7280'}, ${props => `${props.$color}cc` || '#6b7280'});
      color: #ffffff;
      font-size: 1.1rem;
      flex-shrink: 0;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 2px 8px ${props => `${props.$color}30` || 'rgba(0,0,0,0.1)'};
    }

    .category-label {
      font-weight: 700;
      color: #374151;
      font-size: 0.8rem;
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }
  }

  .card-value {
    font-size: 1.6rem;
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.02em;
    line-height: 1;
    margin-top: 0.15rem;
    font-variant-numeric: tabular-nums;
  }
`;